import { useMutation } from "@tanstack/react-query";
import type { UseMutationResult } from "@tanstack/react-query";
import { exportReport } from "../api/evaluation-report-api";
import type {
	ReportExportPayload,
	ReportExportResponse,
} from "../api/evaluation-report-api";

/**
 * Mutation hook for exporting the final report (sync v1 — may take several
 * seconds). On success it opens the server-provided `download_url` in a new tab
 * (never a client-constructed URL). Errors are surfaced via the mutation's
 * `isError`/`error` for ReportPanel's retry banner.
 */
export const useExportReport = (
	rfxId: number | undefined,
	evalId: number | undefined
): UseMutationResult<ReportExportResponse, Error, ReportExportPayload> => {
	return useMutation({
		mutationFn: (payload: ReportExportPayload) =>
			exportReport(rfxId!, evalId!, payload),
		onSuccess: (data) => {
			if (data?.download_url) {
				window.open(data.download_url, "_blank", "noopener,noreferrer");
			}
		},
	});
};
